<button
  type="button"
  class="flex items-center gap-1 pe-6 py-2 animate-fade rounded-full transition-all cursor-pointer text-body md:text-headline-5-medium text-left">
  <mtc-custom-icon svgName="chevronLeft" [size]="'sm'" />

  <span>{{ text() }}</span>
</button>
